import type { ProductColor } from '@aloft/toolkit-shared';
import { isDefined } from '@aloft/toolkit-shared';

import type { BreakdownColumn, Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { isSubRows } from '../types.ts';

export const cellBackgroundColor = (
  col?: BreakdownColumn,
  props?: Tkv2PairedCostSummaryInterfaceV2,
  compId?: string,
) => {
  const backgroundColor: { backgroundColor?: ProductColor } = {};
  if (isDefined(col) && isDefined(props) && !isSubRows(col) && isDefined(col.cellColorFormatter)) {
    backgroundColor.backgroundColor = col.cellColorFormatter({
      ...props,
      compId,
    });
  }

  return backgroundColor;
};
